import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  searchLocationlink(URL, header, success, error) {
    Vue.axios.get(URL + 'llk', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  printLocationlink(URL, header, success, error) {
    Vue.axios.get(URL + 'llkprint', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  exportLocationlink(URL, header, success, error) {
    Vue.axios.get(URL + 'llkexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addLocationlink(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'llk', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editLocationlink(URL, llk_id, obj, header, success, error) {
    Vue.axios.put(URL + 'llk/' + llk_id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteLocationlink(URL, llk_id, header, success, error) {
    Vue.axios.delete(URL + 'llk/' + llk_id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartStore(URL, header, success, error) {
    Vue.axios.get(URL + 'llkpartstore', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/locationlink.js